import { Stack, StackProps } from '@mui/material';
export const StackComponent: React.FC<StackProps> = props => {
  return <Stack {...props}>{props.children}</Stack>;
};
